export const reduceGroupByOptions = (options, groupBy) => {
  const groupOptions = {};
  const nextOptions = [];

  if (groupBy) {

    for (const option of options) {
      const group = groupBy.find(({ filter }) => filter(option.entity));

      if (!group) {
        nextOptions.push(option);
        continue;
      }

      groupOptions[group.label] = [
        ...(groupOptions[group.label] ?? []),
        option,
      ];
    }
  }

  if (!Object.keys(groupOptions).length) {
    return options;
  }

  options = [
    ...Object.entries(groupOptions).map(([label, options]) => ({
      label: <span>{label}</span>,
      title: label,
      options,
    })),
    {
      label: <span>Other</span>,
      title: "Other",
      options: nextOptions,
    },
  ];

  return options;
};
